import {
  ETextExtractionWarningCode,
  type TChatTextExtractionWarningI18nKey,
  type TKnowledgeTextExtractionWarningI18nKey,
} from "../types/text-extraction";

// NOTE: NSAI-7345 — the i18n key each text extraction warning code is worded
// with under a chat message's attachments (the sentence names the file).
export const CHAT_TEXT_EXTRACTION_WARNING_I18N_KEYS: Record<
  ETextExtractionWarningCode,
  TChatTextExtractionWarningI18nKey
> = {
  [ETextExtractionWarningCode.LOW_TEXT]: "chat:textExtractionWarning.low_text",
  [ETextExtractionWarningCode.PAGES_WITHOUT_TEXT]:
    "chat:textExtractionWarning.pages_without_text",
};

// NOTE: NSAI-7345 — the same, on a Knowledge file's row (the tag's tooltip).
export const KNOWLEDGE_TEXT_EXTRACTION_WARNING_I18N_KEYS: Record<
  ETextExtractionWarningCode,
  TKnowledgeTextExtractionWarningI18nKey
> = {
  [ETextExtractionWarningCode.LOW_TEXT]:
    "knowledge:textExtractionWarnings.low_text",
  [ETextExtractionWarningCode.PAGES_WITHOUT_TEXT]:
    "knowledge:textExtractionWarnings.pages_without_text",
};
